export const random = (arr) => arr[Math.floor(Math.random() * arr.length)];
